/**
 * @file Created on Wed Oct 03 2018
 * @author PKl
 */
import ProgressBar from './ProgressBar';
export default ProgressBar;